export enum ModalStatusApproveBatchEnum {
	INACTIVE = 'inactive',
	APPROVAL_CONFIRMATION = 'approvalConfirmation',
	DISCARD_CONFIRMATION = 'discardConfirmation',
	LOADING = 'loading',
	SUCCESS = 'success',
	FAILED = 'failed'
}
